import React from 'react';
import { classNames } from '../utils/classNames';

// A bar that fills from left to right while a long job runs: `value` of `max` parts are done.
// The state `info` (blue) is a job that runs; `critical` (rose) is a job that stopped on a failure,
// so the bar keeps the parts that are done. The caller writes the text around the bar
// ("4 of 13 parts imported"). The bar knows nothing about the job.
export type ProgressBarState = 'info' | 'critical';

type Props = {
	// The accessible name of the bar ("History import").
	label: string,
	value: number,
	max: number,
	state?: ProgressBarState,
};

const FILL: Record<ProgressBarState, string> = {
	info: 'bg-blue-600',
	critical: 'bg-rose-500',
};

const ProgressBar: React.FunctionComponent<Props> = ({ label, value, max, state = 'info' }) => {
	const total = max > 0 ? max : 1;
	const done = Math.min(Math.max(value, 0), total);
	return <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={total} aria-valuenow={done}
							className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
		<div className={classNames('h-2 rounded-full', FILL[state])} style={{ width: `${done / total * 100}%` }} />
	</div>;
};

export default ProgressBar;
